var module = angular.module('octopusApp.configuration');

module.controller('ConfigurationIndexController', function(octopusPermissionSet, $location) {

  octopusPermissionSet.firstAuthorized(["AdministerSystem", "AuditView", "TeamView"]).then(function (p) {
    switch (p) {
      case "AdministerSystem":
        $location.path('/configuration/features');
        break;
      case "AuditView":
        $location.path('/configuration/audit');
        break;
      case "TeamView":
        $location.path('/configuration/teams');
    }
  });
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/overview/configuration_index_controller.js
// module id = 3886506074360910
// module chunks = 1